import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'

const MyFooterForm = ({ loading, btnText, searchIcon, customFunc }) => {
  return (
    <div className="flex justify-end bg-gray-50 p-3 text-center sm:px-6">
      <button
        className={
          'flex justify-center gap-2 rounded-md border border-transparent bg-gray-600 px-4 py-2 ' +
          'text-sm font-medium text-white shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-500' +
          'focus:ring-offset-2 hover:bg-gray-700'
        }
        disabled={loading}
        onClick={customFunc}
        type="submit"
      >
        {loading && (
          <span className="flex items-center">
            <FontAwesomeIcon
              aria-hidden="true"
              className="h-5 w-5 animate-spin text-white group-hover:text-gray-400"
              icon={searchIcon !== undefined ? searchIcon : faSpinner}
            />
          </span>
        )}
        <p className="capitalize">{btnText}</p>
      </button>
    </div>
  )
}

export default MyFooterForm

MyFooterForm.propTypes = {
  loading: PropTypes.bool,
  btnText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  searchIcon: PropTypes.any,
  customFunc: PropTypes.func.isRequired,
}
